export default __webpack_public_path__ + "static/media/card-visa.b083726f.svg";